import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  url: appUrl('session'),
  rootKey: 'session',
});



// WEBPACK FOOTER //
// ./app/models/session.js